import React from "react";
import { Box, Typography, Divider, CircularProgress } from "@mui/material";

const LoadingState = ({ title = "Shared Videos" }) => {
  return (
    <Box
      style={{
        marginTop: 20,
      }}
    >
      <Box>
        <Typography variant="h5">{title}</Typography>
        <Divider style={{ marginTop: 20 }}></Divider>
      </Box>
      <Box
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          height: 500,
        }}
      >
        <CircularProgress style={{ marginTop: 24 }}></CircularProgress>
      </Box>
    </Box>
  );
};

export default LoadingState;
